import classNames from 'classnames';
import React from 'react';

import {TextSkeleton} from '@udemy/react-reveal-components';

import {FeatureList} from '../feature-list/feature-list.react-component';
import styles from './request-demo.module.less';

export interface DemoFormValuePropsProps {
    featureListLoosePadding: boolean;
    features: React.ReactNodeArray;
}

export const DemoFormValuePropsSkeleton = () => {
    return (
        <TextSkeleton
            lineCountPerParagraph={1}
            paragraphCount={5}
            justified={true}
            className={classNames(styles['demo-feature-list-skeleton-item'], 'ud-text-xl')}
        />
    );
};

export const DemoFormValueProps = ({
    featureListLoosePadding,
    features,
}: DemoFormValuePropsProps) => {
    return (
        <div className={styles['demo-feature-list']}>
            <FeatureList
                padding={featureListLoosePadding ? 'loose' : 'normal'}
                features={features}
            />
        </div>
    );
};
